import { Catalogue } from '@ynap/api-utils';
import apiAction from '@ynap/api-fetch-action';
import { getPromoCacheKey } from '../utils/promoCacheKey';
import { fetchDeliveryReturnsContent } from './getDeliveryReturnsContent';

export default (partNumber, uid) => {
    return async (dispatch, getState) => {
        const state = getState();
        const { country, language, langISO } = state.appState;
        const { deliveryAndReturnLegalMessageEnabledCountries } = state.config.head.pdp;
        const { services, application } = state.config.global;
        const { baseUrl, clientId } = services.commerce;
        const configState = state.config;
        const { uberToken } = state.auth;

        const options = {
            locale: langISO,
        };

        const config = { baseUrl, brandId: application.brandId, country, language, partNumber, clientId, configState, options, uberToken };

        const request = Catalogue.getDetailsByPartNumber(config);

        const pdpResponse = await dispatch(apiAction(request, 'PRODUCT_DETAILS', uid, { partNumber }));

        const isDeliveryReturnsEnabledCountry = deliveryAndReturnLegalMessageEnabledCountries?.includes(country?.toUpperCase?.());

        // Fetch delivery & returns content
        if (isDeliveryReturnsEnabledCountry) {
            try {
                await dispatch(fetchDeliveryReturnsContent());
            } catch (error) {
                if (error instanceof Error) {
                    console.log('Error fetching delivery returns content:', error.message);
                }
            }
        }

        // Fetch promo code
        if (typeof window === 'undefined') {
            try {
                const { products } = pdpResponse.json;

                const firstDisplayableProduct = products[0]?.productColours?.[0].sKUs.find((p) => p.displayable === true);

                if (firstDisplayableProduct) {
                    await dispatch(
                        apiAction(Catalogue.getPromoCode({ ...config, options: { partnumber: firstDisplayableProduct.partNumber } }), 'PROMO_PRICE', uid, {
                            cacheKey: getPromoCacheKey(firstDisplayableProduct.partNumber),
                            reqTimeout: 3000,
                        }),
                    );
                }
            } catch (error) {
                console.error('Error fetching promo code', error);
            }
        }

        return pdpResponse;
    };
};

export const updatePromoPrice = (partNumber, uid, userGlobalId) => {
    return async (dispatch, getState) => {
        const state = getState();
        const cacheKey = getPromoCacheKey(partNumber, userGlobalId);
        const isPromoSaved = !!state?.pdp?.promoState?.responses?.[cacheKey];
        const { uberToken } = state.auth;

        if (!isPromoSaved) {
            const { country, language, langISO } = state.appState;
            const { services, application } = state.config.global;
            const { baseUrl, clientId } = services.commerce;
            const configState = state.config;

            const options = {
                locale: langISO,
            };

            const config = { baseUrl, brandId: application.brandId, country, language, partNumber, clientId, configState, options, uberToken };

            try {
                await dispatch(
                    apiAction(Catalogue.getPromoCode({ ...config, options: { partnumber: partNumber } }), 'PROMO_PRICE', uid, {
                        cacheKey,
                        reqTimeout: 3000,
                    }),
                );
            } catch (error) {
                console.error('Error fetching promo code', error);
            }
        }
    };
};
